import { execute } from '@lib/graphql/execute'
import { graphql } from '@lib/graphql/gql'
import { QueryConfig } from '@lib/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'
//ss
const customerOrderQueryDocument = graphql(`
  query CustomerOrderById($id: ID!) {
    order(id: $id) {
      id
      orderNumber
      externalReference
      createdAt
      shipmentState
      lineItems {
        edges {
          node {
            id
            productSlug
            productName
            variantName
            sku
            variant {
              image {
                src
              }
            }
            quantity
            discountApplications {
              edges {
                node {
                  discountedAmount {
                    centAmount
                  }
                }
              }
            }

            unitPrice {
              value {
                ...Money
              }
              discountedPrice {
                value {
                  ...Money
                }
              }
            }
            subtotal {
              ...Money
            }

            total {
              ...Money
            }
          }
        }
      }
      shippingAddress {
        ...Address
      }
      billingAddress {
        ...Address
      }

      orderState
      paymentState
      shipmentState

      shippingLines {
        shippingMethod {
          name
        }
        subtotal {
          centAmount
          currencyCode
          fractionDigits
        }
      }
      subtotal {
        ...Money
      }
      taxedPrice {
        ...TaxedPrice
      }
      total {
        ...Money
      }
    }
  }
  fragment Address on BaseAddress {
    address1
    address2
    city
    company
    countryCode
    email
    firstName
    lastName
    phone
    postalCode
    state
    formatted
  }
  fragment TaxedPrice on TaxedPrice {
    net {
      ...Money
    }
    gross {
      ...Money
    }
  }
  fragment Money on Money {
    centAmount
    currencyCode
    fractionDigits
  }
`)

export const getCustomerOrder = ({ orderId }: { orderId: string }) => {
  return execute(customerOrderQueryDocument, { id: orderId })
}

export const getCustomerOrderQueryOptions = ({
  orderId,
}: {
  orderId: string
}) => {
  return queryOptions({
    queryKey: ['customer', orderId],
    queryFn: () => getCustomerOrder({ orderId }),
  })
}

type UseCustomerOrderOptions = {
  orderId: string
  queryConfig?: QueryConfig<typeof getCustomerOrder>
}

export const useCustomerOrder = ({
  orderId,
  queryConfig,
}: UseCustomerOrderOptions) => {
  return useQuery({
    ...getCustomerOrderQueryOptions({ orderId }),
    ...queryConfig,
  })
}
